module.exports = __webpack_public_path__ + "img/pills--add 1.932a5c2c.svg";